// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3-MbI3aDHuecYhdM9jjzBI","icon-spin":"_2xvtxqno_JCZwKiV_T3Q25","icon-hidden":"w8c_VbF5CC-_AjpaSPPuz","icon-spin-animation":"a65dGPhEYMn--4OBBbYgL"};